//var CaptchaCallback = function () {
//    $('.g-recaptcha').each(function (index, el) {
//        grecaptcha.render(el, {
//            'sitekey': $(el).attr('data-sitekey')
//            , 'theme': $(el).attr('data-theme')
//            , 'size': $(el).attr('data-size')
//            , 'tabindex': $(el).attr('data-tabindex')
//            , 'callback': $(el).attr('data-callback')
//            , 'expired-callback': $(el).attr('data-expired-callback')
//            , 'error-callback': $(el).attr('data-error-callback')
//        });
//    });
//};

//var captchaValid = false;
//function captchaFilled() {
//    captchaValid = true;
//    $('.g-recaptcha-validation').addClass('d-none');
//}

//function captchaExpired() {
//    captchaValid = false;
//    $('.g-recaptcha-validation').removeClass('d-none');
//}

//var newsletterCaptchaValid = false;
//function newsletterCaptchaSucceeded() {
//    newsletterCaptchaValid = true;
//    $('#NewsletterSignupForm').submit();
//}
var SignUpModal = false;

$(function () {
    //if ($('.g-recaptcha').length) {
    //    $('.g-recaptcha').parents('form').not('#NewsletterSignupForm').on('submit', function (e) {
    //        if (!captchaValid) {
    //            e.preventDefault();
    //            $(this).find('.g-recaptcha-validation').removeClass('d-none');
    //            return false;
    //        } else {
    //            $(this).find('.g-recaptcha-validation').addClass('d-none');
    //            return true;
    //        }
    //    });
    //}

    var mouseY = 0;
    var topValue = 0;
    if ($('body').data('signupmodal') == 0) {
        SignUpModal = true;
    }

    window.addEventListener("mouseout", function (e) {
        mouseY = e.clientY;
/*            console.log(SignUpModal);*/
        if (mouseY < topValue && !SignUpModal && !$('#SetUpSubscriptionModal').is(':visible')) {
            $('.mouseleave-pane').removeClass('d-none');
            $('#NewsletterSignupForm').addClass('d-none');
            SignUpModal = true;
            $.get("/modalshown");
            //setCookie('SignUpModal', '1', 60);
            $('#signUpModal').modal('show');
      }
    },
        false);

    $('#NewsletterSignupFormFooter, #NewsletterSignupFormModal').on('submit', function () {
        var EmailAddress = $(this).find('input').val();
        //console.log(EmailAddress);
        $('#SignUpModalEmail').val(EmailAddress);
        $('.voucher-pane').addClass('d-none');
        $('.mouseleave-pane').addClass('d-none');
        $('#NewsletterSignupForm').removeClass('d-none');
        $('#signUpModal').modal('show');
        $('#SignUpModalFirstName').focus();
        if ($(this).find('button').hasClass('modal-signup')) {
            $('#NewsletterSignupForm input[name="IsModal"]').val('true');
        }
        return false;
    });

    //$('#NewsletterSignupForm input').on('focus', function () {
    //    // trigger loading api.js (recaptcha.js) script
    //    //var head = document.getElementsByTagName('head')[0];
    //    //var script = document.createElement('script');
    //    //script.type = 'text/javascript';
    //    //script.src = 'https://www.google.com/recaptcha/api.js?onload=CaptchaCallback&render=explicit';
    //    //head.appendChild(script);

    //    // remove focus to avoid js error:
    //    // Uncaught Error: reCAPTCHA has already been rendered in this element at Object.kh
    //    $('#NewsletterSignupForm input').off('focus');
    //});

    //$('#NewsletterSignupForm').on('submit', function (e) {
    //    if (!newsletterCaptchaValid) {
    //        e.preventDefault();
    //        //grecaptcha.execute($('#NewsletterCaptcha').index('.g-recaptcha'));
    //        return false;
    //    } else {
    //        return true;
    //    }
    //});

    $('[data-toggle="popover"]').popover();

    if (!sessionStorage.getItem('BlackFridayModalShown')) {
        $('#blackfriday-modal').on('shown.bs.modal', function () {
            $('.modal-backdrop').addClass('modal-backdrop-blackfriday')
        }).modal('show');
        sessionStorage.setItem('BlackFridayModalShown', 'true');
    }

    Modernizr.on('webpalpha', function (result) {
        if (result) {
            $('[data-src-webp]').each(function () {
                if ($(this).data('src-webp') !== '') {
                    if ($(this).hasClass('lazy')) {
                        $(this).attr('data-src', $(this).data('src-webp'));
                    } else {
                        $(this).attr('src', $(this).data('src-webp'));
                    }
                }
                $(this).removeAttr('data-src-webp');
            });
        }
    });

    var last_known_scroll_position = 0;
    var ticking = false;

    function resizeHeader(scroll_pos) {
        if (scroll_pos > 100 && scroll_pos == $('.sticky-lg-top').first().offset().top) {
            $('.navbar').removeClass('shadow-sm').addClass('shadow');
            $('.navbar-brand').addClass('py-0');
        } else if (scroll_pos == 0) {
            $('.navbar').removeClass('shadow').addClass('shadow-sm');
            $('.navbar-brand').removeClass('py-0');
        }
    }

    window.addEventListener('scroll', function (e) {
        last_known_scroll_position = $(document).scrollTop();

        if (!ticking) {
            window.requestAnimationFrame(function () {
                resizeHeader(last_known_scroll_position);
                ticking = false;
            });

            ticking = true;
        }
    });

    PointerEventsPolyfill.initialize({});
});

function NewsletterSignupBegin() {
    $('#NewsletterSignupFormFooter button').prop('disabled', true);
}

function NewsletterSignupComplete(data) {
    $('#NewsletterSignupFormFooter button').prop('disabled', false);
    $('#NewsletterSignupFormFooter input').val('');
    if (data.responseJSON.success) {
        $('#NewsletterSignupForm').addClass('d-none');
        $('.voucher-pane').removeClass('d-none');
        $('.signup-voucher-message').text(data.responseJSON.message);
        $('.signup-voucher-code').text(data.responseJSON.vouchercode);
        //} else {
        //    $('#NewsletterSignupForm #Email').addClass('input-validation-error');
        //    $('#NewsletterSignupForm [data-valmsg-for="Email"]').removeClass('field-validation-valid').addClass('field-validation-error').html(data.responseJSON.message);
    }

    SignUpModal = true;
}

/* requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel | MIT license
 * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
 * http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating */
(function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame']
            || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function (callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function () { callback(currTime + timeToCall); },
                timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
}());


/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-webpalpha-setclasses !*/
!function (n, e, o) { function t(n) { var e = u.className, o = Modernizr._config.classPrefix || ""; if (A && (e = e.baseVal), Modernizr._config.enableJSClass) { var t = new RegExp("(^|\\s)" + o + "no-js(\\s|$)"); e = e.replace(t, "$1" + o + "js$2") } Modernizr._config.enableClasses && (e += " " + o + n.join(" " + o), A ? u.className.baseVal = e : u.className = e) } function s(n, e) { return typeof n === e } function a() { var n, e, o, t, a, i, f; for (var c in l) if (l.hasOwnProperty(c)) { if (n = [], e = l[c], e.name && (n.push(e.name.toLowerCase()), e.options && e.options.aliases && e.options.aliases.length)) for (o = 0; o < e.options.aliases.length; o++)n.push(e.options.aliases[o].toLowerCase()); for (t = s(e.fn, "function") ? e.fn() : e.fn, a = 0; a < n.length; a++)i = n[a], f = i.split("."), 1 === f.length ? Modernizr[f[0]] = t : (!Modernizr[f[0]] || Modernizr[f[0]] instanceof Boolean || (Modernizr[f[0]] = new Boolean(Modernizr[f[0]])), Modernizr[f[0]][f[1]] = t), r.push((t ? "" : "no-") + f.join("-")) } } function i(n, e) { if ("object" == typeof n) for (var o in n) c(n, o) && i(o, n[o]); else { n = n.toLowerCase(); var s = n.split("."), a = Modernizr[s[0]]; if (2 == s.length && (a = a[s[1]]), "undefined" != typeof a) return Modernizr; e = "function" == typeof e ? e() : e, 1 == s.length ? Modernizr[s[0]] = e : (!Modernizr[s[0]] || Modernizr[s[0]] instanceof Boolean || (Modernizr[s[0]] = new Boolean(Modernizr[s[0]])), Modernizr[s[0]][s[1]] = e), t([(e && 0 != e ? "" : "no-") + s.join("-")]), Modernizr._trigger(n, e) } return Modernizr } var r = [], l = [], f = { _version: "3.6.0", _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function (n, e) { var o = this; setTimeout(function () { e(o[n]) }, 0) }, addTest: function (n, e, o) { l.push({ name: n, fn: e, options: o }) }, addAsyncTest: function (n) { l.push({ name: null, fn: n }) } }, Modernizr = function () { }; Modernizr.prototype = f, Modernizr = new Modernizr; var c, u = e.documentElement, A = "svg" === u.nodeName.toLowerCase(); !function () { var n = {}.hasOwnProperty; c = s(n, "undefined") || s(n.call, "undefined") ? function (n, e) { return e in n && s(n.constructor.prototype[e], "undefined") } : function (e, o) { return n.call(e, o) } }(), f._l = {}, f.on = function (n, e) { this._l[n] || (this._l[n] = []), this._l[n].push(e), Modernizr.hasOwnProperty(n) && setTimeout(function () { Modernizr._trigger(n, Modernizr[n]) }, 0) }, f._trigger = function (n, e) { if (this._l[n]) { var o = this._l[n]; setTimeout(function () { var n, t; for (n = 0; n < o.length; n++)(t = o[n])(e) }, 0), delete this._l[n] } }, Modernizr._q.push(function () { f.addTest = i }), Modernizr.addAsyncTest(function () { var n = new Image; n.onerror = function () { i("webpalpha", !1, { aliases: ["webp-alpha"] }) }, n.onload = function () { i("webpalpha", 1 == n.width, { aliases: ["webp-alpha"] }) }, n.src = "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==" }), a(), t(r), delete f.addTest, delete f.addAsyncTest; for (var p = 0; p < Modernizr._q.length; p++)Modernizr._q[p](); n.Modernizr = Modernizr }(window, document);